import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../FormInputs/formInput.css";
import "./formDateInput.css";
import {
  DATE_FNS_DATE_FORMAT,
  DATE_FNS_DATETIME_FORMAT,
  DATE_PLACEHOLDER,
  DATETIME_PLACEHOLDER,
  isoToDate,
  dateToIso,
  dateToIsoDateTime,
} from "./dateFormat";

/**
 * Drop-in replacement for <FormInputs type="date" /> on the fee plan and fee
 * payment pages: the person types and sees dd-mm-yy (with a calendar popup),
 * but `value` / `min` / `max` and the value handed to `onChange` stay ISO
 * ("YYYY-MM-DD"), so all the existing comparisons and API payloads are
 * untouched. onChange gets a FormInputs-style event: { target: { name, value } }.
 *
 * showTime: date + time ("YYYY-MM-DDTHH:mm", what datetime-local used).
 */
function FormDateInput({
  label = "",
  required = false,
  showError = false,
  disabled = false,
  value = "",
  onChange = () => {},
  min,
  max,
  name,
  placeholder,
  showTime = false,
  popperPlacement = "bottom-start",
}) {
  const hasError = showError && required && !value;

  const handleChange = (date) => {
    const next = date ? (showTime ? dateToIsoDateTime(date) : dateToIso(date)) : "";
    onChange({ target: { name, value: next } });
  };

  return (
    <div className="formInput formDateInput">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <DatePicker
        selected={isoToDate(value)}
        onChange={handleChange}
        dateFormat={showTime ? DATE_FNS_DATETIME_FORMAT : DATE_FNS_DATE_FORMAT}
        placeholderText={placeholder || (showTime ? DATETIME_PLACEHOLDER : DATE_PLACEHOLDER)}
        minDate={isoToDate(min)}
        maxDate={isoToDate(max)}
        disabled={disabled}
        name={name}
        // Only a complete, valid "dd-mm-yy" counts - half-typed text never
        // turns into a surprise date.
        strictParsing
        autoComplete="off"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        yearDropdownItemNumber={15}
        showTimeInput={showTime}
        timeInputLabel="Time:"
        todayButton="Today"
        showPopperArrow={false}
        className={hasError ? "input-error" : ""}
        wrapperClassName="formDateInput-wrapper"
        popperClassName="formDateInput-popper"
        popperPlacement={popperPlacement}
        // Rendered outside the table/accordion so overflow:auto wrappers
        // can't clip the calendar.
        portalId="fee-datepicker-portal"
      />
    </div>
  );
}

export default FormDateInput;